import React, { useEffect, useState } from "react";
import MenuSection from "../../components/menu-section";
import { MenuItem } from "../../types";
import { useMenuHubApi } from "../../api/menuHub";
import champagnat from "../../assets/logo_champganhe.png";
import cajuru from "../../assets/logo_cajuru.png";
import {
    MenuSectionSkeleton,
    PainelShimmerChrome,
} from "../../components/skeletons";
import { useTheme } from "../../theme/useTheme";

const Dashboard: React.FC = () => {
    const [menu, setMenu] = useState<MenuItem[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const { isDarkMode } = useTheme();
    const { getPainels } = useMenuHubApi();

    useEffect(() => {
        const fetchMenu = async () => {
            try {
                setLoading(true);
                const data = await getPainels();
                setMenu(Array.isArray(data?.solucoes) ? data?.solucoes : []);
            } catch (err) {
                console.error("Erro ao carregar o menu:", err);
                setMenu([]);
            } finally {
                setLoading(false);
            }
        };

        fetchMenu();
    }, []);

    const grouped = Array.isArray(menu)
        ? menu.reduce<Record<string, MenuItem[]>>((acc, item) => {
            if (!acc[item.titulo]) acc[item.titulo] = [];
            acc[item.titulo].push(item);
            return acc;
        }, {})
        : {};

    const colors: Record<string, Record<string, any>> = {
        "Hospital São Marcelino Champagnat": {
            headerColor: "#ED1C24",
            borderColor: isDarkMode ? "#5a2a2e" : "#FFB8BA",
            icon: <img src={champagnat} style={{ width: "52px", height: "32px" }} alt="" />,
            hover: isDarkMode ? "#2a1520" : "#FFF0F0",
            press: isDarkMode ? "#3d1f24" : "#FFD2D2",
        },
        "Hospital Universitário Cajuru": {
            headerColor: "#4190C1",
            borderColor: isDarkMode ? "#2a4a62" : "#4190C1",
            icon: <img src={cajuru} style={{ width: "32px", height: "32px" }} alt="" />,
            hover: isDarkMode ? "#152433" : "#F3FAFF",
            press: isDarkMode ? "#1a3044" : "#C1E3FB",
        },
        "Gestão Complexo Saúde": {
            headerColor: "#009535",
            borderColor: isDarkMode ? "#1f4a32" : "#4AC762",
            icon: (
                <div className="flex-center-row">
                    <img src={champagnat} style={{ width: "52px", height: "32px" }} alt="" />
                    <img src={cajuru} style={{ width: "32px", height: "32px", marginLeft: "1rem" }} alt="" />
                </div>
            ),
            hover: isDarkMode ? "#15251c" : "#F3FFF9",
            press: isDarkMode ? "#1a3022" : "#D4FFEA",
        },
    };

    return (
        <PainelShimmerChrome isDarkMode={isDarkMode}>
            <div>
                {loading ? (
                    <MenuSectionSkeleton isDarkMode={isDarkMode} />
                ) : !menu.length ? (
                    <p>Nenhum painel disponível.</p>
                ) : (
                    Object.keys(grouped).map((titulo) => (
                        <MenuSection
                            key={titulo}
                            titulo={titulo}
                            items={grouped[titulo]}
                            color={colors[titulo]?.headerColor || "#999"}
                            borderColor={colors[titulo]?.borderColor || "#999"}
                            icon={colors[titulo]?.icon}
                            hover={colors[titulo]?.hover}
                            press={colors[titulo]?.press}
                            isDarkMode={isDarkMode}
                        />
                    ))
                )}
            </div>
        </PainelShimmerChrome>
    );
};

export default Dashboard;
